<div *ngLet=" {
     partsData: selectCartPartItems$ | async,
     hasCouponData: hasCouponData$ | async,
     currencyCode: currencyCode$ | async
    } as vm">
  <div class="billing-table table-responsive view-all p-5">
    <div class="billing-right d-flex justify-content-between py-3 my-3">
      <div style="float: left; ">
        <h5 class="strong mb-0">My cart</h5>
        @if (vm.partsData && vm.partsData.length == 1) {
          <span id="checkout_span_CartsDataEqualSingleItem">Item
          ({{vm.partsData.length}})</span>
        }
        @if (vm.partsData && vm.partsData.length > 1) {
          <span id="checkout_span_CartsDataEqualMultipleItems">Items
          ({{vm.partsData.length}})</span>
        }
      </div>
      <button id="x" (click)="closeModal()">
        X
      </button>
    </div>
    <ng-container>
      @if (!vm.partsData || vm.partsData.length <= 0) {
        <div id="checkout_div_NoCartDataMessage">
          cart item is not available.
        </div>
      }
      @if (vm.partsData && vm.partsData.length > 0) {
        <div id="checkout_div_CartDataPresent">
          <div id="parts_list" cardClass="checkout-cart">
            <table style="width: 100%;">
              <thead>
                <tr>
                  <th style="width: 20%; padding-left: 2%; font-weight: 200; ">Part</th>
                  <th style="width: 66%; text-align: end; font-weight: 200; ">Quantity</th>
                  <th style="width: 8%; padding-right: 2%; text-align: end; font-weight: 200; ">Price</th>
                  <th ></th>
                </tr>
              </thead>
            </table>
            <div class="table-scroll parts-list">
              <table class="table tbody">
                @for (partItem of vm.partsData; track partItem; let i = $index) {
                  <tbody id="checkout_tbody_CartItem_{{i}}">
                    <tr class="non-coupon-row">
                      <td >
                        <div class="d-flex flex-row" style="width: 95%; " >
                          <div style="float:left">
                            <img [src]="getImage(partItem.image, imageBaseUrl, '48X48')"
                              [default]="'assets/img/48X48_No_Image.png'" tabindex="-1" alt="No Image">
                            </div>
                            <div style="float:right; margin-left: 4%;">
                              <div style="margin-bottom: 2%;">
                                {{partItem.description}}
                              </div>
                              <div class="text-truncate" title="{{partItem.partNumber}}">{{partItem.partNumber}}</div>
                              <div>
                                @if (partItem.corePrice>0 && partItem.partNumber != 'PARTSBUYOUTTX' ) {
                                  <span id="checkout_span_CorePriceAndNotPartsBuyoutTX"
                                    >
                                    {{
                                    (partItem.coreOption
                                    == "NOCORER") ? "No Core Returned" : "Core Returned"
                                    }}
                                  </span>
                                }
                                @if (partItem.corePrice>0 && partItem.partNumber == 'PARTSBUYOUTTX') {
                                  <span id="checkout_span_CorePriceAndPartsBuyoutTX"
                                    >
                                    {{ partItem.partBuyoutCoreOption == 'NOCORE' ? 'No Core' : '' }}
                                    {{ partItem.partBuyoutCoreOption == 'NICORE' ? 'Non-Inventory Core' : '' }}
                                    {{ partItem.partBuyoutCoreOption == 'NICORER' ? 'Non-Inventory Core w Return' : '' }}
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="text-start" style="margin-left: -20px; " >{{partItem.quantity}}</td>
                        <td class="text-end" style="margin-left: -20px; ">
                          @if (partItem.couponTotal > 0) {
                            <div class="checkout-cart -price"
                              [ngClass]="[partItem.isSpecialPricing || vm.hasCouponData ? 'text-danger':'',partItem.lowestPriceWithoutCoupon - partItem.couponTotal != partItem.finalPrice?'strikethrough':'']">
                              {{(partItem.quantity * (partItem.finalPrice + ((partItem.coreOption == "NOCORER" ||
                              partItem.partBuyoutCoreOption == 'NICORE')? partItem.corePrice : 0)) ) |
                              currency: vm.currencyCode :'symbol':'1.2-2'}}
                            </div>
                            <div class="checkout-cart-price">
                              {{(partItem.quantity * (partItem.finalPrice + ((partItem.coreOption == "NOCORER" ||
                              partItem.partBuyoutCoreOption == 'NICORE')? partItem.corePrice : 0)) - partItem.couponTotal) |
                              currency: vm.currencyCode :'symbol':'1.2-2'}}
                            </div>
                          }
                          @if (partItem.couponTotal <= 0) {
                            <div class="checkout-cart-price">
                              {{(partItem.quantity * (partItem.finalPrice + ((partItem.coreOption == "NOCORER" ||
                              partItem.partBuyoutCoreOption == 'NICORE')? partItem.corePrice : 0)) ) |
                              currency: vm.currencyCode :'symbol':'1.2-2'}}
                            </div>
                          }
                        </td>
                        <td>
                          @if (partItem.isPriceVerified) {
                            <a id="checkout_div_CartItemIsPriceVerified"
                              class="btn price-verify-icon" style="cursor:default; color:#fff;">
                              v
                            </a>
                          }
                        </td>
                      </tr>
                      @for (coupon of partItem.sapCoupons; track coupon) {
                        <tr style="line-height: 10px; height: 1px;" height="5px"
                          class="coupon-row">
                          <td style="width: 95%; height: 1px; text-align: start; padding-left: 10.5%;">
                            @if (coupon.type === 'part') {
                              <span style="color:green;"> {{coupon.description}} applied</span>
                            }
                          </td>
                          <td style="margin-left: -20px; " ></td>
                          <td style="margin-left: -20px; " ></td>
                          <td></td>
                        </tr>
                      }
                    </tbody>
                  }
                </table>
              </div>
            </div>
          </div>
        }
      </ng-container>
    </div>
  </div>

  <button (click)="closeModal()" class="btn close-btn btn-default black-btn">Close</button>
